import { addNavMenuItem, registerBulkAction, addNavMenuSection } from '@vendure/admin-ui/core';
import {
    assignPromotionsToChannelBulkAction,
    deleteDealsBulkAction,
    duplicatePromotionsBulkAction,
    removePromotionsFromChannelBulkAction,
} from './components/deals-list/deals-list-bulk-actions';

export default [
    addNavMenuItem(
        {
            id: 'deals',
            label: 'Deals',
            icon: 'event',
            routerLink: ['/extensions/deals'],
        },
        'marketing',
    ),
    registerBulkAction(deleteDealsBulkAction),
    registerBulkAction(assignPromotionsToChannelBulkAction),
    registerBulkAction(removePromotionsFromChannelBulkAction),
    registerBulkAction(duplicatePromotionsBulkAction),
];
